// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import { ColumnsType } from "antd/lib/table";
import i18n from "i18next";
import DateFormat from "../../../../utils/DateFormat";
import { MissingUser } from "./MissingUserListsScreen";

const emailSorting = (missingUser1: MissingUser, missingUser2: MissingUser) => {
  if (missingUser1.email < missingUser2.email) {
    return -1;
  }
  if (missingUser1.email > missingUser2.email) {
    return 1;
  }
  return 0;
};

const attemptNumberSorting = (
  missingUser1: MissingUser,
  missingUser2: MissingUser
) => {
  return missingUser1.attemptNumber - missingUser2.attemptNumber;
};

const lastAttemptSorting = (
  missingUser1: MissingUser,
  missingUser2: MissingUser
) => {
  return (
    missingUser1.lastAttempt.getTime() - missingUser2.lastAttempt.getTime()
  );
};

export const columns: ColumnsType<MissingUser> = [
  {
    title: i18n.t("missing_users.table.email"),
    key: "email",
    dataIndex: "email",
    sorter: emailSorting,
    defaultSortOrder: undefined
  },
  {
    title: i18n.t("missing_users.table.attemptNumber"),
    key: "attemptNumber",
    dataIndex: "attemptNumber",
    sorter: attemptNumberSorting,
    defaultSortOrder: undefined
  },
  {
    title: i18n.t("missing_users.table.lastAttempt"),
    key: "lastAttempt",
    dataIndex: "lastAttempt",
    sorter: lastAttemptSorting,
    defaultSortOrder: "descend",
    render: (lastAttempt: Date) => {
      return DateFormat.standardDate(lastAttempt);
    }
  }
];
